import React from 'react';
import { whyChooseUs } from '../utils/mockData';
import { Crosshair, Users, CheckCircle, Award, Clock } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';

const iconMap = {
  Crosshair: Crosshair,
  Users: Users,
  CheckCircle: CheckCircle,
  Award: Award,
  Clock: Clock
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Your Trusted Surveying Partner
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Industry-leading expertise and commitment to excellence in every project
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="group hover:shadow-xl transition-all duration-300 border-0 bg-white hover:-translate-y-1 cursor-pointer"
              >
                <CardHeader className="p-8">
                  <div className="mb-4">
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors">
                    {item.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
